import { MODULE as PARENT } from '../constants'

export const KEY = 'price-calculator'
export const MODULE = [...[PARENT], KEY]

export const FETCH_INFO = `${MODULE.join('/')}-fetch`
export const CLEAR_INFO = `${MODULE.join('/')}-clear`
